import { useState } from "react";

const AnnonceSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images.length) % images.length
    );
  };

  return (
    <div className="slider-container">
      {images.length > 0 ? (
        <>
          <button className="prev-btn" onClick={prevImage}>
            ❮
          </button>
          <img
            src={images[currentIndex]}
            alt={`Annonce ${currentIndex + 1}`}
            className="annonce-image"
          />
          <button className="next-btn" onClick={nextImage}>
            ❯
          </button>
        </>
      ) : (
        <p>Aucune image disponible</p>
      )}    </div>
  );
};

export default AnnonceSlider;
